export const LeagueFormatter = (installingType) => {
  switch (installingType) {
    case 1:
      return "لیگ برنز";
    case 2:
      return "لیگ نقره‌ای";
    case 3:
      return "لیگ طلایی";
    default:
      return "";
  }
};
